import React, { useState, useRef, useEffect } from "react";
import MultiSelect from "../../components/profile/multi_select";
import { FilterButton } from "../../components/profile/multi_select2";
import axios from "axios";
import SingleSelect from "../../components/profile/single_select";
import { useAsyncError, useNavigate } from "react-router-dom";
import LoadingBlack from "../../images/loading-black.svg"; // Ensure you have the loading.svg in the correct path

// Add custom styles
const customStyles = {
  saveButton: {
    marginLeft: "1.5rem"
  }
};

const Form = ({
  candidate,
  setCandidate,
  selectedSection,
  setSelectedSection,
  candidateNeedUpdate,
  setCandidateNeedUpdate,
}) => {
  const navigate = useNavigate();

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedTech, setSelectedTech] = useState([]);
  const [selectedCodingLanguages, setSelectedCodingLanguages] = useState([]);
  const [selectedRolesSWE, setSelectedRolesSWE] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedSalesExperience, setSelectedSalesExperience] = useState([]);
  const [selectedWorkingStyle, setSelectedWorkingStyle] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const [editSavedMessage, setEditSavedMessage] = useState(false); // "Edit Saved" notification state
  const [successMessage, setSuccessMessage] = useState(null); // Add success message state

  useEffect(() => {
    if (candidate != "yes" && candidateNeedUpdate) {
      console.log(candidate);
      setSelectedLanguages(candidate.languages || []);
      setSelectedTech(candidate.proficient_technologies || []);
      setSelectedCodingLanguages(candidate.coding_languages || []);
      setSelectedRolesSWE(candidate.swe_roles || []);
      setSelectedRoles(candidate.roles || []);
      setSelectedIndustries(candidate.industries_interested || []);
      setSelectedSalesExperience(candidate.sales_experience || []);
      setSelectedWorkingStyle(candidate.working_style || []);

      // ADD THIS: make sure `candidate.marketing_portfolio` is set
      if (candidate.fields && candidate.fields["Marketing portfolio RAW"]) {
        setCandidate((prev) => ({
          ...prev,
          marketing_portfolio: candidate.fields["Marketing portfolio RAW"],
          video: candidate.fields["Video intro (new)"] || ""
        }));
      }
      
      setCandidateNeedUpdate(false);
    }
  }, [candidate]);

  // Clear messages when changing sections
  useEffect(() => {
    setMessage(null);
    setSuccessMessage(null);
  }, [selectedSection]);

  const [file, setFile] = useState(null);
  const [showPostgrad, setShowPostgrad] = useState(false);

  const degree_types = [
    "BSc",
    "BA",
    "BEng",
    "LLB",
    "MEng (Integrated)",
    "MEng",
    "BCom",
    "MA",
    "MBiol",
    "MBiochem",
    "MSci",
    "MBBS",
    "B.Eng.",
    "BBA",
    "MChem",
    "MPhys",
    "MSc",
    "BASc",
    "MEng with Year",
    "BBS",
    "MBChB",
    "Major",
    "BMus",
    "Bachelor",
    "Diploma",
    "MD",
    "BM",
    "BNutSci",
    "Graduate Certificate",
    "BA Degree Apprenticeship",
    "International BA",
    "BM BCh",
    "MBBS, iBSc",
    "BMS",
    "Diploma of Higher Education",
    "MBA",
    "MB BChir",
    "BTech",
    "BTEC",
    "MMath",
    "Licentiate degree",
    "OND",
    "MSc Integrated Masters",
    "Degree Classification",
    "MA (Integrated Masters)",
    "BCom & BInfoTech"
  ];

  const post_degree_types = [
    "MSc",
    "MA",
    "MBA",
    "MEng",
    "LLM",
    "MPhil",
    "PhD",
    "MSci",
    "MSc Integrated Masters",
    "MSt",
    "MBBS",
    "MA + MEng",
    "Masters Cert.",
    "Honours Degree",
    "GDL",
    "Professional Graduate Diploma"
  ];

  const degree_result = ["1st Class", "2:1","2:2", "Merit", "Pass"];

  const tech = ["SQL", "No code/low code", "Python", "Excel/Google sheet"];

  const work_style = [
    "5 days a week in office",
    "Hybrid (1-4 days in office)",
    "Fully remote",
  ];

  const salaries = [];
  for (let i = 25; i <= 60; i += 5) {
    salaries.push(`£${i}k`);
  }
  salaries.push("£60k+");

  const rtw = [
    "Yes - British Passport",
    "Yes - Irish Passport",
    "Yes - Post Study Visa",
    "Yes - Settlement Status / Indefinite Leave to Remain",
    "No - I require Visa sponsorship to work in the UK",
    "Other",
  ];

  const salesExperience = [
    "Account management",
    "Cold calling",
    "Email outreach",
    "Partnerships",
    "Designing sales playbook",
    "New business development",
    "N/A",
  ];

  const industries = [
    "FinTech",
    "Artificial Intelligence (AI)",
    "Cybersecurity",
    "B2B SaaS",
    "Education",
    "B2C",
    "PropTech",
    "Crypto / Blockchain",
    "Healthcare",
    "eCommerce",
    "LegalTech",
    "Social Impact",
    "Sustainability / Climate",
  ];

  const roles = [
    "Founder Associate",
    "Generalist",
    "Operations",
    "Marketing",
    "Product",
    "Data Analyst",
    "Sales/Commercial",
    "Customer Success",
    "People Ops",
  ];

  const rolesSWE = [
    "Front End Developer",
    "Back End Developer",
    "Full stack Developer",
    "Other",
  ];
  const salary = [
    "£25k",
    "£30k",
    "£35k",
    "£40k",
    "£45k",
    "£50k",
    "£55k",
    "£60k",
    "£60k+",
  ];
  const commision = [
    "No expectation",
    "£5k",
    "£10k",
    "£15k",
    "£20k",
    "£25k",
    "£30k",
    "£35k",
    "£40k",
    "£45k",
    "£50k",
    "£55k",
    "£55k+",
  ];
  const salarySWE = [
    "£40k",
    "£45k",
    "£50k",
    "£55k",
    "£60k",
    "£65k",
    "£70k",
    "£75k",
    "£80k",
    "£85k",
    "£90k",
    "£95k",
    "£100k",
    "£100k+",
  ];

  const [showMoreLanguages, setShowMoreLanguages] = useState(false);
  const moreLanguages = [
    "Bengali",
    "Croatian",
    "Dutch",
    "Farsi",
    "Greek",
    "Gujarati",
    "Italian",
    "Japanese",
    "Korean",
    "Lithuanian",
    "Norwegian",
    "Nepali",
    "Panjabi",
    "Portuguese",
    "Persian",
    "Polish",
    "Russian",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Vietnamese",
    "Yoruba",
  ];

  const languages = [
    "Arabic",
    "French",
    "German",
    "Spanish",
    "Mandarin",
    "Hindi",
  ];

  const [showMoreCodingLanguages, setShowMoreCodingLanguages] = useState(false);
  // Most common coding languages from the screenshot
  const codingLanguages = [
    "Python",
    "JavaScript",
    "Java",
    "C#",
    "C++",
    "Typescript",
  ];

  // Additional coding languages from the screenshot
  const moreCodingLanguages = [
    "C",
    "Dart",
    "Go",
    "Kotlin",
    "Swift",
    "Rust",
    "PHP",
    "Ruby",
    "Perl",
    "Scala",
    "Objective-C",
    "Elixir",
    "Clojure",
    "Haskell",
    "Angular",
    "React",
    "Vue",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCandidate({ ...candidate, [name]: value });
  };

  const handleChangeSingleSelect = (name, value) => {
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: prevCandidate[name] === value ? "" : value,
    }));
  };

  const [message, setMessage] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const getRequiredFields = (candidateStream) => {
    const baseRequiredFields = [
      "cv",
      "linkedin",
      "name",
      "lastName",
      "phone_number",
      "work_experience_1_role",
      "work_experience_1_company",
      "work_experience_1_description",
      "work_experience_2_role",
      "work_experience_2_company",
      "work_experience_2_description",
      "top_achievement",
      "minimum_salary",
      "ideal_salary",
      "right_to_work",
    ];
    
    // Only add "roles" as required for Generalist and Marketing candidates
    let required = [...baseRequiredFields];
    if (candidateStream === "Generalist" || candidateStream === "Marketing") {
      required.push("roles");
    }
    // Require video intro for Sales candidates
    if (candidateStream === "Sales") {
      required.push("video");
    }
    return required;
  };

  const requiredFields = getRequiredFields(candidate.stream);

  const fieldToSectionMap = {
    cv: "1. General Information",
    linkedin: "1. General Information",
    name: "1. General Information",
    lastName: "1. General Information",
    phone_number: "1. General Information",
    video: "1. General Information",
    work_experience_1_role: "5. Work Experience",
    work_experience_1_company: "5. Work Experience",
    work_experience_1_description: "5. Work Experience",
    work_experience_2_role: "5. Work Experience",
    work_experience_2_company: "5. Work Experience",
    work_experience_2_description: "5. Work Experience",
    top_achievement: "3. Skills",
    working_style: "6. Future Position",
    minimum_salary: "6. Future Position",
    ideal_salary: "6. Future Position",
    right_to_work: "6. Future Position",
    roles: "6. Future Position",
  };

  const missingFields = requiredFields.filter((field) => {
    // Special handling for roles which is stored in selectedRoles array
    if (field === "roles") {
      return selectedRoles.length === 0;
    }
    return !candidate[field];
  });

  const isButtonDisabled = missingFields.length > 0;

  const handleFieldClick = (field) => {
    const section = fieldToSectionMap[field];
    if (section) {
      setSelectedSection(section);
    }
  };

  // Add this function to validate salary range
  const validateSalaryRange = () => {
    if (candidate.minimum_salary && candidate.ideal_salary) {
      const minSalary = parseInt(candidate.minimum_salary.replace(/[^0-9]/g, ''));
      const idealSalary = parseInt(candidate.ideal_salary.replace(/[^0-9]/g, ''));
      
      if (minSalary > idealSalary) {
        return "Minimum salary cannot be higher than ideal salary.";
      }
      
      if (idealSalary - minSalary > 15) {
        return "The gap between minimum and ideal salary cannot exceed £15k.";
      }
    }
    return null;
  };

  const updateCandidate = async (updatedCandidate) => {
    try {
      // Validate salary range before updating
      const salaryError = validateSalaryRange();
      if (salaryError) {
        // Show error message and don't proceed with update
        setMessage(salaryError);
        setTimeout(() => {
          setMessage(null);
        }, 5000);
        return;
      }

      setLoading(true); // Start loading animation
      const token = localStorage.getItem("token");

      // Check if a file is uploaded
      let fileUrl = null;
      let photoUpdated = false;
      if (file) {
        fileUrl = await handleUpload();
        photoUpdated = true;
        if (!fileUrl) {
          setMessage("Failed to upload profile picture. Please try again.");
          setLoading(false);
          return;
        }
      }

      // Validate required fields
      for (const field of requiredFields) {
        // Special handling for roles which is stored in selectedRoles array
        if (field === "roles") {
          if (selectedRoles.length === 0) {
            throw new Error(`Missing required field: ${field}`);
          }
        } else if (!updatedCandidate[field]) {
          throw new Error(`Missing required field: ${field}`);
        }
      }

      // Transform the state to match the backend field structure
      const fields = {};

      const entries = {
        "Years of exp (or commercial exp)": updatedCandidate.years_of_exp,
        "CV RAW": updatedCandidate.cv, // Use uploaded file URL if available
        "LinkedIn RAW": updatedCandidate.linkedin,
        Name: updatedCandidate.name,
        Surname: updatedCandidate.lastName,
        "Phone number": updatedCandidate.phone_number,
        "Undergrad degree type": updatedCandidate.undergrad_degree_type,
        "Undergrad subject": updatedCandidate.undergrad_degree_subject,
        "Undergrad university": updatedCandidate.undergrad_university,
        "Undergrad result": updatedCandidate.undergrad_result,
        "Undergrad graduation year": updatedCandidate.undergrad_graduation_year ? parseInt(updatedCandidate.undergrad_graduation_year, 10) || null : null,
        "Postgrad degree type": updatedCandidate.postgrad_degree_type,
        "Postgrad subject": updatedCandidate.postgrad_degree_subject,
        "Postgrad university": updatedCandidate.postgrad_university,
        "Postgrad graduation year": updatedCandidate.postgrad_graduation_year ? parseInt(updatedCandidate.postgrad_graduation_year, 10) || null : null,
        "Postgrad result": updatedCandidate.postgrad_result,
        "Industry experience": updatedCandidate.industry_experience,
        "Time spent coding": updatedCandidate.time_spent_coding,
        "Coding languages new": selectedCodingLanguages,
        "(1) Work Experience Role": updatedCandidate.work_experience_1_role,
        "(1) Work Experience Company":
          updatedCandidate.work_experience_1_company,
        "(1) Work Experience Description":
          updatedCandidate.work_experience_1_description,
        "(1) Time spent in work experience YRS":
          updatedCandidate.work_experience_1_duration_yrs,
        "(1) Time spent in work experience MOS":
          updatedCandidate.work_experience_1_duration_mos,
        "(2) Work Experience Role": updatedCandidate.work_experience_2_role,
        "(2) Work Experience Company":
          updatedCandidate.work_experience_2_company,
        "(2) Work Experience Description":
          updatedCandidate.work_experience_2_description,
        "(2) Time spent in work experience YRS":
          updatedCandidate.work_experience_2_duration_yrs,
        "(2) Time spent in work experience MOS":
          updatedCandidate.work_experience_2_duration_mos,
        "Most impressive thing SWE": updatedCandidate.most_impressive_swe,
        "Github RAW": updatedCandidate.github,
        "Portfolio Top Achievement": updatedCandidate.portfolio_top_achievement,
        "Top achievement": updatedCandidate.top_achievement,
        "Proficient technologies copy": selectedTech,
        "Recent target achieved": updatedCandidate.recent_target,
        "Sales experience - skills": updatedCandidate.sales_experience,
        "Marketing portfolio RAW": updatedCandidate.marketing_portfolio,
        "English proficiency swe": updatedCandidate.english_proficiency,
        "Languages copy": selectedLanguages,
        "Generalist roles suitable for copy": selectedRoles,
        //"SWE relevant roles": selectedRolesSWE,
        "Industries most interested in copy": selectedIndustries,
        "Open to any industries": updatedCandidate.open_to_any_industries,
        "Industries NOT interested in":
          updatedCandidate.industries_not_interested,
        "Additional context on next role preferences":
          updatedCandidate.role_preferences_context,
        "Preferred working style copy": selectedWorkingStyle,
        "Minimum salary": updatedCandidate.minimum_salary,
        "Ideal salary": updatedCandidate.ideal_salary,
        "Commission expectation (sales only)":
          updatedCandidate.commission_expectation,
        "Salary context": updatedCandidate.salary_context,
        "RTW doc": updatedCandidate.right_to_work,
        "Proven Sales Experience / High Potential for Sales":
          updatedCandidate.sales,
      };

      const photoUrl = fileUrl || candidate.image;
      if (photoUrl) {
        entries.Photo = [{ url: photoUrl }];
      }

      // Dynamically populate fields, excluding empty or undefined values
      Object.entries(entries).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          (typeof value !== "string" || value.trim() !== "")
        ) {
          fields[key] = value;
        }
      });

      // Handle clearing the video intro explicitly: set to null if removed
      if (typeof updatedCandidate.video === 'string') {
        const cleanedVideo = updatedCandidate.video.trim();
        fields["Video intro (new)"] = cleanedVideo.length > 0 ? cleanedVideo : null;
      } else if (updatedCandidate.video == null) {
        fields["Video intro (new)"] = null;
      }

      console.log("DEBUG: Full payload sent to backend:", { id: updatedCandidate.id, fields });
      console.log(fields.Photo);

      const response = await axios.patch(
        `/api/candidates/updateCandidate`,
        { id: updatedCandidate.id, fields },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCandidateNeedUpdate(true);

      if (response.status === 200) {
        setCandidateNeedUpdate(true);
        console.log("Candidate updated successfully");
        
        // Show the "Edit Saved" message
        setEditSavedMessage(true);
         // 1) Force local candidate to reflect whatever the user typed in that field
         setCandidate((prev) => ({
           ...prev,
           marketing_portfolio: updatedCandidate.marketing_portfolio,
           video: updatedCandidate.video,
           roles: selectedRoles
         }));
        
        // Show success message
        if (photoUpdated) {
          setSuccessMessage("Profile and profile picture updated successfully!");
        } else {
          setSuccessMessage("Profile updated successfully!");
        }
        
        // Hide the messages after a few seconds
        setTimeout(() => {
          setEditSavedMessage(false);
          setSuccessMessage(null);
        }, 3000);
        
        setLoading(false); // End loading animation
      } else {
        throw new Error("Failed to update candidate");
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      setMessage(`Error: ${error.message}`);
      setTimeout(() => {
        setMessage(null);
      }, 5000);
      setLoading(false);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a file to upload.");
      return null;
    }

    const CLOUDINARY_CLOUD_NAME = "dkjsnpplv";
    const CLOUDINARY_UPLOAD_PRESET = "ml_default";
    const CLOUDINARY_API_KEY = "815772339983468";
    const CLOUDINARY_FOLDER = "ProfilePictureCandidate";

    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;

    try {
      const {
        data: { signature, timestamp },
      } = await axios.get("/api/cloudinary/signaturePP", {
        params: { upload_preset: CLOUDINARY_UPLOAD_PRESET },
      });

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("timestamp", timestamp);
      formData.append("api_key", CLOUDINARY_API_KEY);
      formData.append("signature", signature);
      formData.append("folder", CLOUDINARY_FOLDER);

      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccessMessage("File uploaded successfully!");
      setTimeout(() => {
        setSuccessMessage(null);
      }, 3000);
      return response.data.secure_url; // Return the uploaded file URL
    } catch (error) {
      setMessage(
        `Error: ${error.response ? error.response.data.message : error.message}`
      );
      return null;
    }
  };

  const options =
    candidate.stream === "Software Engineering" ? salarySWE : salaries;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
      <form className="relative gap-y-6 rounded-lg max-w-[720px] flex flex-col">
        {message && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md">
            {message}
          </div>
        )}
        {successMessage && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-700 rounded-md">
            {successMessage}
          </div>
        )}
        {selectedSection === "1. General Information" && (
          <>
            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 w-full max-w-[700px] min-w-[500px]`}
            >
              <h2 className="text-2xl font-medium mb-6">General Information</h2>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={candidate.name}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="lastName"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Surname
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    placeholder="lastName"
                    value={candidate.lastName}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    placeholder="james@gmail.com"
                    value={candidate.email}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="phone_number"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Phone Number
                  </label>
                  <input
                    id="phone_number"
                    name="phone_number"
                    placeholder="+44 749 938 401"
                    value={candidate.phone_number}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
              </div>
            </div>

            <>
              <div
                className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
              >
                <h2 className="text-3xl font-semibold">Links</h2>
                <div>
                  <label
                    htmlFor="cv"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    CV{" "}
                    <span className="italic text-sm font-normal text-gray-700">
                      - Please make sure the link is accessible to everyone.{" "}
                      <a
                        href="https://jumpstart-alumni.notion.site/Improve-your-CV-cc1105b48daf48079d29a08682619659?pvs=74"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        Click here
                      </a>{" "}
                      for guidance on how to create a great CV.
                    </span>
                  </label>

                  <input
                    id="cv"
                    name="cv"
                    placeholder="https://drive.google.com/file/d/1sw05wh0hD"
                    value={candidate.cv}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="linkedin"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    LinkedIn
                  </label>
                  <input
                    id="linkedin"
                    name="linkedin"
                    placeholder="https://www.linkedin.com/in/john-smith/"
                    value={candidate.linkedin}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="duration_role1"
                    className="block text-md font-semibold leading-6 text-gray-900 pb-1"
                  >
                    Video intro{" "}
                    {candidate.stream === "Sales" && (
                      <span className="ml-1 text-red-600" title="Required">*</span>
                    )}
                    <span className="italic text-sm font-normal text-gray-700">
                      - Please record using{" "}
                      <a
                        href={"https://www.loom.com"}
                        className="hover:underline text-blue-500 cursor-pointer"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Loom
                      </a>{" "}
                      and paste the link below{" "}
                      <a
                        href="https://jumpstart-alumni.notion.site/Creating-your-video-introduction-8bf3ec68015a440d88ffed6a4e337cb2"
                        className="hover:underline text-blue-500 cursor-pointer"
                        target="_blank"
                        rel="noopener noreferrer"
                        >
        (guidance here)
      </a>
                    </span>
                  </label>
                  <input
                    id="video"
                    name="video"
                    placeholder="loom.com/share/your-video-here"
                    value={candidate.video}
                    onChange={handleChange}
                    className={`block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset placeholder:text-gray-400 sm:text-md sm:leading-6 
                      ${candidate.stream === "Sales" && !candidate.video
                        ? 'ring-red-400 focus:ring-red-500 focus:border-red-500 bg-red-50'
                        : 'ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-indigo-600'}`}
                  />
                </div>
                {candidate.stream === "Software Engineering" && (
                  <>
                    <div>
                      <label
                        htmlFor="github"
                        className="block text-md font-semibold leading-6 text-gray-900"
                      >
                        Github
                      </label>

                      <input
                        id="github"
                        name="github"
                        placeholder="https://drive.google.com/file/d/1sw05wh0hD"
                        value={candidate.github}
                        onChange={handleChange}
                        className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="portfolio_swe"
                        className="block text-md font-semibold leading-6 text-gray-900"
                      >
                        Portfolio
                      </label>

                      <input
                        id="portfolio_swe"
                        name="portfolio_swe"
                        placeholder="https://drive.google.com/file/d/1sw05wh0hD"
                        value={candidate.portfolio_swe}
                        onChange={handleChange}
                        className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>{" "}
                  </>
                )}


{(candidate.stream === "Marketing" || candidate.stream === "Generalist") && (
  <div>
    <label
      htmlFor="marketing_portfolio"
      className="block text-md font-semibold leading-6 text-gray-900"
    >
      Portfolio
    </label>
    <input
      id="marketing_portfolio"
      name="marketing_portfolio"
      placeholder="https://myportfolio.com"
      value={candidate.marketing_portfolio || ""}
      onChange={handleChange}
      className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900
        ring-1 ring-inset ring-gray-300 placeholder:text-gray-400
        focus:ring-1 focus:ring-inset focus:ring-indigo-600
        sm:text-md sm:leading-6"
    />
  </div>
)}



              </div>
            </>
          </>
        )}
        {selectedSection === "2. Profile Picture" && (
          <>
            <div className="relative space-y-4 bg-white rounded-xl -mt-2 p-6 w-full max-w-[700px]">
              <h2 className="text-2xl font-medium mb-6">Profile Picture</h2>

              <div>
                <label
                  className="block mb-2 text-md font-semibold text-gray-900"
                  htmlFor="profile_image"
                >
                  Upload a new profile picture
                </label>
                <input
                  className="block w-full mb-5 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                  id="profile_image"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </div>
              
              {file && (
                <div className="mt-4">
                  <p className="text-sm text-gray-600 mb-2">Selected file: {file.name}</p>
                  <p className="text-sm text-green-600">Click "Save changes" below to update your profile picture</p>
                </div>
              )}
            </div>
          </>
        )}
        {/* 3. Skills */}
        {selectedSection === "3. Skills" && (
          <>
            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
            >
              <h2 className="text-3xl font-semibold">Skills</h2>
              <div className="grid gap-4">
                {candidate.stream === "Sales" && (
                                  <div>
                  <label
                    htmlFor="recent_target"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Recent target achieved{" "}
                  </label>
                  <textarea
                    id="recent_target"
                    name="recent_target"
                    rows="2"
                    className="block w-full pl-2 rounded-lg bg-transparent border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                    placeholder="A few lines on the type of candidate you are looking for!"
                    value={candidate.recent_target}
                    onChange={handleChange}
                  ></textarea>
                </div>
                )}

                <div>
                  <label
                    htmlFor="top_achievement"
                    className="block text-md font-semibold leading-6 text-gray-900"
                  >
                    Top achievement
                  </label>
                  <textarea
                    id="top_achievement"
                    name="top_achievement"
                    rows="2"
                    className="block w-full pl-2 rounded-lg bg-transparent border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                    placeholder="Fully developed Jumpstart's product while following a MSc at UCL!"
                    value={candidate.top_achievement}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
              {candidate.stream === "Software Engineering" ? (
                <>
                  <div>
                    <label
                      htmlFor="surname"
                      className="block text-md font-semibold leading-6 text-gray-900 pb-2"
                    >
                      Coding Languages
                    </label>
                    <div className="gap-2 flex flex-wrap">
                      {codingLanguages.map((option) => (
                        <FilterButton
                          key={option}
                          label={option}
                          selectedOptions={selectedCodingLanguages}
                          setSelectedOptions={setSelectedCodingLanguages}
                        />
                      ))}
                      {showMoreCodingLanguages &&
                        moreCodingLanguages.map((option) => (
                          <FilterButton
                            key={option}
                            label={option}
                            selectedOptions={selectedCodingLanguages}
                            setSelectedOptions={setSelectedCodingLanguages}
                          />
                        ))}

                      {/* More button */}
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setShowMoreCodingLanguages(!showMoreCodingLanguages);
                        }}
                        className="py-2 px-4 rounded-md hover:bg-gray-200 text-black font-semibold"
                      >
                        {showMoreCodingLanguages ? "Show Less" : "Show More"}
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label
                      htmlFor="surname"
                      className="block text-md font-semibold leading-6 text-gray-900 pb-2"
                    >
                      Technologies
                    </label>
                    <div className="gap-2 flex flex-wrap">
                      {tech.map((option) => (
                        <FilterButton
                          key={option}
                          label={option}
                          selectedOptions={selectedTech}
                          setSelectedOptions={setSelectedTech}
                          maxSelected={3}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}
              <div>
                <label
                  htmlFor="name"
                  className="block text-md font-semibold leading-6 text-gray-900 pb-2"
                >
                  Languages
                </label>
                <div className="gap-2 flex flex-wrap">
                  {/* Display main languages */}
                  {languages.map((option) => (
                    <FilterButton
                      key={option}
                      label={option}
                      selectedOptions={selectedLanguages}
                      setSelectedOptions={setSelectedLanguages}
                      maxSelected={4}
                    />
                  ))}

                  {/* Display more languages if `showMore` is true */}
                  {showMoreLanguages &&
                    moreLanguages.map((option) => (
                      <FilterButton
                        key={option}
                        label={option}
                        selectedOptions={selectedLanguages}
                        setSelectedOptions={setSelectedLanguages}
                        maxSelected={4}
                      />
                    ))}

                  {/* More button */}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowMoreLanguages(!showMoreLanguages);
                    }}
                    className="py-2 px-4 rounded-md hover:bg-gray-200 text-black font-semibold"
                  >
                    {showMoreLanguages ? "Show Less" : "Show More"}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Previous Work 5. Work Experience */}
        {selectedSection === "5. Work Experience" && (
          <>
            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
            >
              <h2 className="text-3xl font-semibold">
                Primary Work Experience
              </h2>
              <div className="grid grid-cols-5 gap-4">
                <div className="col-span-2">
                  <label
                    htmlFor="work_experience_1_role"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Role title
                  </label>
                  <input
                    id="work_experience_1_role"
                    name="work_experience_1_role"
                    placeholder="Software Engineer"
                    value={candidate.work_experience_1_role}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div className="col-span-2">
                  <label
                    htmlFor="work_experience_1_company"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Company
                  </label>
                  <input
                    id="work_experience_1_company"
                    name="work_experience_1_company"
                    placeholder="Jumpstart"
                    value={candidate.work_experience_1_company}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div className="col-span-1">
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label
                        htmlFor="work_experience_1_duration_yrs"
                        className="block text-md font-semibold text-gray-900"
                      >
                        Years
                      </label>
                      <input
                        id="work_experience_1_duration_yrs"
                        name="work_experience_1_duration_yrs"
                        type="number"
                        min="0"
                        max="5"
                        placeholder="0-5"
                        value={candidate.work_experience_1_duration_yrs}
                        onChange={(e) => {
                          const inputValue =
                            e.target.value === ""
                              ? ""
                              : parseInt(e.target.value, 10);
                              if (inputValue === "" || (inputValue >= 0 && inputValue <= 5)) {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: inputValue,
                              },
                            });
                          }
                        }}
                        className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="work_experience_1_duration_mos"
                        className="block text-md font-semibold text-gray-900"
                      >
                        Months
                      </label>
                      <input
                        id="work_experience_1_duration_mos"
                        name="work_experience_1_duration_mos"
                        type="number"
                        min="0"
                        max="11"
                        placeholder="0-11"
                        value={candidate.work_experience_1_duration_mos}
                        onChange={(e) => {
                          const inputValue =
                            e.target.value === ""
                              ? ""
                              : parseInt(e.target.value, 10);
                          if (
                            inputValue === "" ||
                            (inputValue >= 0 && inputValue <= 11)
                          ) {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: inputValue,
                              },
                            });
                          }
                        }}
                        className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label
                  htmlFor="work_experience_1_description"
                  className="block text-md font-semibold text-gray-900"
                >
                  One liner
                </label>
                <textarea
                  id="work_experience_1_description"
                  name="work_experience_1_description"
                  rows="2"
                  className="block w-full pl-2 rounded-lg bg-transparent border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  placeholder="I fully developed the tech platform used by all of JS clients."
                  value={candidate.work_experience_1_description}
                  onChange={(e) => {
                    const wordLimit = 30;
                    const words = e.target.value
                      .split(/\s+/)
                      .filter((word) => word.length > 0);
                    if (words.length <= wordLimit) {
                      handleChange(e);
                    }
                  }}
                ></textarea>
                <p className="mt-1 text-sm text-gray-600">
                  {candidate.work_experience_1_description
                    ? candidate.work_experience_1_description
                        .split(/\s+/)
                        .filter((word) => word.length > 0).length
                    : 0}
                  /30 words
                </p>
              </div>
            </div>

            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
            >
              <h2 className="text-3xl font-semibold">
                Secondary Work Experience
              </h2>
              <div className="grid grid-cols-5 gap-4">
                <div className="col-span-2">
                  <label
                    htmlFor="work_experience_2_role"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Role title
                  </label>
                  <input
                    id="work_experience_2_role"
                    name="work_experience_2_role"
                    placeholder="Software Engineer"
                    value={candidate.work_experience_2_role}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div className="col-span-2">
                  <label
                    htmlFor="work_experience_2_company"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Company
                  </label>
                  <input
                    id="work_experience_2_company"
                    name="work_experience_2_company"
                    placeholder="Jumpstart"
                    value={candidate.work_experience_2_company}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>

                <div className="col-span-1">
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label
                        htmlFor="work_experience_2_duration_yrs"
                        className="block text-md font-semibold text-gray-900"
                      >
                        Years
                      </label>
                      <input
                        id="work_experience_2_duration_yrs"
                        name="work_experience_2_duration_yrs"
                        type="number"
                        min="0"
                        max="5"
                        placeholder="0-5"
                        value={candidate.work_experience_2_duration_yrs}
                        onChange={(e) => {
                          const inputValue =
                            e.target.value === ""
                              ? ""
                              : parseInt(e.target.value, 10);
                          if (
                            inputValue === "" ||
                            (inputValue >= 0 && inputValue <= 5)) {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: inputValue,
                              },
                            });
                          }
                        }}
                        className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="work_experience_2_duration_mos"
                        className="block text-md font-semibold text-gray-900"
                      >
                        Months
                      </label>
                      <input
                        id="work_experience_2_duration_mos"
                        name="work_experience_2_duration_mos"
                        type="number"
                        min="0"
                        max="11"
                        placeholder="0-11"
                        value={candidate.work_experience_2_duration_mos}
                        onChange={(e) => {
                          const inputValue =
                            e.target.value === ""
                              ? ""
                              : parseInt(e.target.value, 10);
                          if (
                            inputValue === "" ||
                            (inputValue >= 1 && inputValue <= 11)) {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: inputValue,
                              },
                            });
                          }
                        }}
                        className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label
                  htmlFor="work_experience_2_description"
                  className="block text-md font-semibold text-gray-900"
                >
                  One liner
                </label>
                <textarea
                  id="work_experience_2_description"
                  name="work_experience_2_description"
                  rows="2"
                  className="block w-full pl-2 rounded-lg bg-transparent border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  placeholder="I fully developed the tech platform used by all of JS clients."
                  value={candidate.work_experience_2_description}
                  onChange={(e) => {
                    const wordLimit = 30;
                    const words = e.target.value
                      .split(/\s+/)
                      .filter((word) => word.length > 0);
                    if (words.length <= wordLimit) {
                      handleChange(e);
                    }
                  }}
                ></textarea>
                <p className="mt-1 text-sm text-gray-600">
                  {candidate.work_experience_2_description
                    ? candidate.work_experience_2_description
                        .split(/\s+/)
                        .filter((word) => word.length > 0).length
                    : 0}
                  /30 words
                </p>
              </div>
            </div>
          </>
        )}
        {/* 4. Education */}
        {selectedSection === "4. Education" && (
          <>
            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px] min-w-[500px]`}
            >
              <h2 className="text-3xl font-semibold">
                Undergraduate Education
              </h2>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="undergrad_degree_subject"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Subject
                  </label>
                  <input
                    id="undergrad_degree_subject"
                    name="undergrad_degree_subject"
                    placeholder="Computer Science"
                    value={candidate.undergrad_degree_subject}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="undergrad_degree_type"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Degree classification
                  </label>
                  <SingleSelect
                    options={degree_types}
                    selectedOptions={candidate.undergrad_degree_type}
                    field={"undergrad_degree_type"}
                    onChange={handleChangeSingleSelect}
                  />
                </div>

                <div>
                  <label
                    htmlFor="undergrad_university"
                    className="block text-md font-semibold text-gray-900"
                  >
                    University
                  </label>
                  <input
                    id="undergrad_university"
                    name="undergrad_university"
                    placeholder="University College London"
                    value={candidate.undergrad_university}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
                <div>
                  <label
                    htmlFor="undergrad_result"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Results
                  </label>
                  <SingleSelect
                    options={degree_result}
                    selectedOptions={candidate.undergrad_result}
                    field={"undergrad_result"}
                    onChange={handleChangeSingleSelect}
                  />
                </div>
                <div>
                  <label
                    htmlFor="undergrad_graduation_year"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Graduation year
                  </label>
                  <input
                    id="undergrad_graduation_year"
                    name="undergrad_graduation_year"
                    placeholder="2024"
                    value={candidate.undergrad_graduation_year}
                    onChange={handleChange}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                  />
                </div>
              </div>
            </div>
            {candidate.postgrad_degree_subject ||
            candidate.postgrad_degree_type ||
            candidate.postgrad_university ||
            candidate.postgrad_result ||
            candidate.postgrad_graduation_year ||
            showPostgrad ? (
              <div
                className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
              >
                <h2 className="text-3xl font-semibold">
                  Postgraduate Education
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="postgrad_degree_subject"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Subject
                    </label>
                    <input
                      id="postgrad_degree_subject"
                      name="postgrad_degree_subject"
                      placeholder="Computer Science"
                      value={candidate.postgrad_degree_subject}
                      onChange={handleChange}
                      className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="postgrad_degree_type"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Degree classification
                    </label>
                    <SingleSelect
                      options={post_degree_types}
                      selectedOptions={candidate.postgrad_degree_type}
                      field={"postgrad_degree_type"}
                      onChange={handleChangeSingleSelect}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="postgrad_university"
                      className="block text-md font-semibold text-gray-900"
                    >
                      University
                    </label>
                    <input
                      id="postgrad_university"
                      name="postgrad_university"
                      placeholder="University College London"
                      value={candidate.postgrad_university}
                      onChange={handleChange}
                      className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="postgrad_result"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Results
                    </label>
                    <SingleSelect
                      options={degree_result}
                      selectedOptions={candidate.postgrad_result}
                      field={"postgrad_result"}
                      onChange={handleChangeSingleSelect}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="postgrad_graduation_year"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Graduation date
                    </label>
                    <input
                      id="postgrad_graduation_year"
                      name="postgrad_graduation_year"
                      placeholder="2024"
                      value={candidate.postgrad_graduation_year}
                      onChange={handleChange}
                      className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="text-black rounded-md hover:bg-gray-200 py-4 flex justify-center"
                onClick={() => setShowPostgrad(true)}
              >
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6 mr-2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
                Add postgraduate degree
              </button>
            )}
          </>
        )}
        {/* Future Position */}
        {selectedSection === "6. Future Position" && (
          <>
            <div
              className={`relative space-y-4 bg-white rounded-xl -mt-2 p-6 max-w-[700px]`}
            >
              <h2 className="text-3xl font-semibold">Future Position</h2>
              <div className="flex gap-4">
                <div>
                  <label
                    htmlFor="minimum_salary"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Min Salary
                  </label>
                  <SingleSelect
                    options={options}
                    selectedOptions={candidate.minimum_salary}
                    field={"minimum_salary"}
                    onChange={handleChangeSingleSelect}
                  />
                </div>
                <div>
                  <label
                    htmlFor="ideal_salary"
                    className="block text-md font-semibold text-gray-900"
                  >
                    Ideal Salary
                  </label>
                  <SingleSelect
                    options={options}
                    selectedOptions={candidate.ideal_salary}
                    field={"ideal_salary"}
                    onChange={handleChangeSingleSelect}
                  />
                </div>
                {candidate.stream === "Sales" && (
                  <div>
                    <label
                      htmlFor="Commission"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Commission
                    </label>
                    <SingleSelect
                      options={commision}
                      selectedOptions={candidate.commission_expectation}
                      field={"commission_expectation"}
                      onChange={handleChangeSingleSelect}
                    />
                  </div>
                )}
                <div className="flex gap-4">
                  <div>
                    <label
                      htmlFor="right_to_work"
                      className="block text-md font-semibold text-gray-900"
                    >
                      Right to work in the UK
                    </label>
                    <SingleSelect
                      options={rtw}
                      selectedOptions={candidate.right_to_work}
                      field={"right_to_work"}
                      onChange={handleChangeSingleSelect}
                    />
                  </div>
                </div>
              </div>

              <div>
                <label
                  htmlFor="working_style"
                  className="block text-md font-semibold text-gray-900"
                >
                  What working styles are you open to?{" "}
                  <span className="italic text-sm text-gray-600">
                    (select all that apply)
                  </span>
                </label>
                <div className="gap-2 flex flex-wrap mt-2">
                  {work_style.map((option) => (
                    <FilterButton
                      key={option}
                      label={option}
                      selectedOptions={selectedWorkingStyle}
                      setSelectedOptions={setSelectedWorkingStyle}
                    />
                  ))}
                </div>
              </div>

              {candidate.stream === "Software Engineering" && (
                <>
                  <div className="hidden">
                    <label
                      htmlFor="roles"
                      className="block text-md font-semibold text-gray-900 pb-2"
                    >
                      Roles best suited for
                    </label>
                    <div className="gap-2 flex flex-wrap">
                      {/* Display main languages */}
                      {rolesSWE.map((option) => (
                        <FilterButton
                          key={option}
                          label={option}
                          selectedOptions={selectedRolesSWE}
                          setSelectedOptions={setSelectedRolesSWE}
                        />
                      ))}
                    </div>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      className="hidden mt-2 py-2 px-6 border rounded-full justify-center items-center flex text-sm border-gray-400 hover:border-gray-600 hover:bg-black/5"
                    >
                      Other
                    </button>
                  </div>
                </>
              )}

              {candidate.stream === "Generalist" && (
                <>
                  <div>
                    <label
                      htmlFor="roles"
                      className="block text-md font-semibold text-gray-900 pb-2"
                    >
                      Roles best suited for
                    </label>
                    <div className="gap-2 flex flex-wrap">
                      {/* Display main languages */}
                      {roles.map((option) => (
                        <FilterButton
                          key={option}
                          label={option}
                          selectedOptions={selectedRoles}
                          setSelectedOptions={setSelectedRoles}
                          maxSelected={3}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}

              {candidate.stream === "Sales" && (
                <>
                  <div>
                    <label
                      htmlFor="roles"
                      className="block text-md font-semibold text-gray-900 pb-2"
                    >
                      Sales experience
                    </label>
                    <div className="gap-2 flex flex-wrap">
                      {/* Display main languages */}
                      {salesExperience.map((option) => (
                        <FilterButton
                          key={option}
                          label={option}
                          selectedOptions={selectedSalesExperience}
                          setSelectedOptions={setSelectedSalesExperience}
                          maxSelected={3}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}

              <div>
                <label
                  htmlFor="industries"
                  className="block text-md font-semibold text-gray-900 pb-2"
                >
                  Industries most interested in
                </label>
                <div className="gap-2 flex flex-wrap">
                  {/* Display main languages */}
                  {industries.map((option) => (
                    <FilterButton
                      key={option}
                      label={option}
                      selectedOptions={selectedIndustries}
                      setSelectedOptions={setSelectedIndustries}
                      maxSelected={4}
                    />
                  ))}
                </div>
              </div>
              <div>
                <label
                  htmlFor="industries_not_interested"
                  className="block text-md font-semibold text-gray-900"
                >
                  Industries definitely not interested in
                </label>
                <input
                  id="industries_not_interested"
                  name="industries_not_interested"
                  placeholder="Fintech, Agritech"
                  value={candidate.industries_not_interested}
                  onChange={handleChange}
                  className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-md sm:leading-6"
                />
              </div>
            </div>
          </>
        )}
      </form>
      
      {missingFields.length > 0 && candidate != "yes" && (
        <div className="text-red-500 mb-4 ml-6 max-w-[700px] flex">
          <p>
            Missing:{" "}
            {missingFields.map((field, index) => (
              <span
                key={field}
                onClick={() => handleFieldClick(field)}
                className="cursor-pointer hover:underline"
              >
                {field.replace(/_/g, " ")}
                {index < missingFields.length - 1 && ", "}
              </span>
            ))}
          </p>
        </div>
      )}

      <div className="px-6 mt-6">
        <button
          onClick={(e) => {
            e.preventDefault();
            updateCandidate(candidate);
          }}
          className={`flex items-center py-3 px-6 rounded-lg border-2 ${
            isButtonDisabled
              ? "bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300"
              : "bg-[#02B491] text-white hover:bg-gray-100 hover:text-black border-[#02B491]"
          }`}
          disabled={isButtonDisabled}
        >
          {loading ? (
            <img src={LoadingBlack} className="h-6 fill-red-500" alt="Loading" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6 mr-2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
              />
            </svg>
          )}
          {loading ? "" : "Save changes"}
        </button>
      </div>

      {editSavedMessage && (
        <div
          className="fixed divide-x flex top-10 right-10 border z-50 justify-between items-center w-full max-w-[400px] p-4 bg-white rounded-lg shadow-lg mb-4"
          role="alert"
        >
          <div className="text-sm font-normal text-gray-500 flex">
            <svg
              className="text-green-500 mr-1 h-5 w-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
            Edit saved
          </div>

          <div className="flex items-center space-x-2 pl-2">
            <button
              onClick={() => navigate("/roles")}
              className="text-sm flex font-medium text-[#02B491] hover:bg-gray-100 rounded-lg p-1.5"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="size-5 mr-1"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                />
              </svg>
              View roles
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Form;
